import { render, staticRenderFns } from "./MenuBarTenantCenter.vue?vue&type=template&id=5a30af8d&lang=pug"
import script from "./MenuBarTenantCenter.vue?vue&type=script&lang=js"
export * from "./MenuBarTenantCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports